<template>
  <div>
    <CRow>
      <CCol col="12" class="mb-2">
        <CButton color="success" class="w-100" @click="download">
          <i class="fa fa-download" aria-hidden="true"></i> 객체 검출 주석 정보 다운로드
        </CButton>
      </CCol>
    </CRow>
    <DiseaseImageComponent :properties="component.disease"></DiseaseImageComponent>
    <CRow>
      <CCol md="6" lg="6" xxl="4">
        <CCard>
          <CCardHeader>
            <circle-icon></circle-icon>
            지역별 발생수
          </CCardHeader>
          <CCardBody class="p-1">
            <DiseaseAreaCountMapComponent :properties="component.area" style="min-height: 334px">
            </DiseaseAreaCountMapComponent>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol md="6" lg="6" xxl="8">
        <CCard>
          <CCardHeader>
            <circle-icon></circle-icon>
            {{ areaText }} 분석 요청 이미지
          </CCardHeader>
          <CCardBody>
            <DiseaseAreaGalleryComponent :properties="component.gallery" style="height: 300px">
            </DiseaseAreaGalleryComponent>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import DiseaseImageComponent from "@/components/analysis/DiseaseImageComponent";
import DiseaseAreaGalleryComponent from "@/components/analysis/DiseaseAreaGalleryComponent";
import DiseaseAreaCountMapComponent from "@/components/analysis/DiseaseAreaCountMapComponent";
import DiseaseService from "@/services/disease/disease.service";
import core from "@/core";

export default {
  name: "DiseaseAnalysisComponent",
  components: {
    DiseaseImageComponent,
    DiseaseAreaGalleryComponent,
    DiseaseAreaCountMapComponent,
  },
  props: {
    properties: {
      type: Object,
      default: () => {
        return {
          cropCode: "",
        };
      },
    },
  },
  data() {
    return {
      areaText: "전국",
      component: {
        disease: {
          cropCode: null,
          analysis: null,
          callback: null,
        },
        area: {
          cropCode: "0",
          callback: null,
        },
        gallery: {
          searchColumns: null,
          event: null,
          callback: null,
        },
      },
    };
  },
  watch: {
    "properties.cropCode"(cropCode) {
      this.changeCropCode(cropCode);
    },
    "component.area.callback"(event) {
      if (event != null) {
        //console.log("val : ", val);
        this.component.gallery.searchColumns = {
          sidoCode: event.sidoCode,
          sggCode: event.sggCode,
          cropCode: event.cropCode,
        };
        // 지역 텍스트 추가
        this.areaText = `${event.sidoName} ${event.sggName}`;
      }
    },
    "component.gallery.callback"(event) {
      if (event != null) {
        this.component.disease.analysis = event.item;
        // 스크롤바 위로 올리기
        window.scrollTo(0, 0);
        //console.log("item : ", item);
      }
    },
    "component.disease.callback"(event) {
      if (event != null) {
        //console.log("item : ", event);
        this.component.gallery.event = event;
      }
    },
  },
  methods: {
    async changeCropCode(cropCode) {
      this.component.disease.cropCode = cropCode;

      this.component.area.cropCode = cropCode;
      this.component.gallery.searchColumns = {
        cropCode: this.component.area.cropCode,
      };
      this.areaText = "전국";
    },

    async download() {
      core.loader.show("데이터 요청중...");
      try {
        const downloadUri = await DiseaseService.getAnnotationFile(this.component.disease.cropCode);
        console.log("downloadUri : ", downloadUri);
        core.loader.show("다운로드중...");
        await core.http.downloadFile(downloadUri);
      } catch (e) {
        console.log(e);
      }
      core.loader.hide();
    },
  },
};
</script>
